
export default {
	props: {
		item: {
			type: Object,
			default: () => ({}),
		},
		tooltip: {
			type: Object,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		hideRightSide: {
			type: Boolean,
			default: false,
		},
	},
	validations: {
		item: {
			isSelected: {},
		},
	},
}
